export interface Message<T = unknown> {
  subject?: string;
  message: string;
  type: 'critical' | 'error' | 'warning' | 'success' | 'info';
  icon?: string;
  data?: T;
}
